import React from "react";

// ----------------importing components------------------
import Banner from "./Banner/Banner";
import OurHotels from "./Section 2 Our Hotels/OurHotels";

const Hotels = () => {
  return (
    <>
      <Banner />
      <OurHotels />
    </>
  );
};

export default Hotels;
